import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";
import { createMRTColumnHelper } from "material-react-table";
import CustomTable from "../../../../components/custom_table/CustomTable";
import { useSelector } from "react-redux";
import { baseUrl } from "../../../../helper/urls";
import { Chip } from "@mui/material";
const PendingBookings = () => {
   const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [pendingBookings, setPendingBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPendingBookings = async () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${baseUrl}/bookings/getBookingPendingCounselor`,
        { headers }
      );

      const data = response.data.data || [];

      // Add formattedReqId here
      const processedData = data.map((item) => ({
        ...item,
        formattedReqId: `DDR000${item.reqId || ""}`,
        studentName: `${item.studentFirstName || ""} ${
          item.studentLastName || ""
        }`.trim(),
        interestedIn: item.counselorinterestedIn || "",
      }));

      setPendingBookings(processedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setError("Failed to fetch bookings");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingBookings();
  }, []);

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("actions", {
      header: "Actions",
      Cell: ({ row }) => {
        const { status, Scheduled, approved_slots } = row.original;
        console.log(Scheduled, "Scheduled");

        const handleClick = () => {
          if (status !== 0) {
            navigate("/essay-counseling-slot");
          }
        };

        return (
          <Box>
            {approved_slots !== Scheduled && (
              <button
                onClick={handleClick}
                className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                style={{ cursor: "pointer" }}
              >
                <Icon
                  icon="material-symbols:create-new-folder-outline"
                  width={18}
                />
              </button>
            )}
          </Box>
        );
      },
    }),

    columnHelper.accessor("studentName", {
      header: "Student Name",
    }),

    columnHelper.accessor("interestedIn", {
      header: "Service Type",
    }),

    columnHelper.accessor("approved_slots", {
      header: "Total Slots",
      Cell: (cell) => cell.row.original?.approved_slots ?? 0,
    }),
    columnHelper.accessor("Scheduled", {
      header: "Scheduled Slots",
      Cell: (cell) => cell.row.original?.Scheduled ?? 0,
    }),

    columnHelper.accessor("Unscheduled", {
      header: "Pending Slots",
      Cell: (cell) => {
        return (
          <Chip label={cell.row.original?.Unscheduled ?? 0} color="warning" />
        );
      },
    }),
    columnHelper.accessor("formattedReqId", {
      header: "Request ID",
    }),
  ];

  return (
    <CustomTable columns={columns} data={pendingBookings} loading={loading} />
  );
};

export default PendingBookings;

// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Box } from "@mui/material";
// import { Icon } from "@iconify/react";
// import { createMRTColumnHelper } from "material-react-table";
// import CustomTable from "../../../../components/custom_table/CustomTable";
// import { baseUrl } from "../../../../helper/urls";
// import { Chip } from "@mui/material";
// import { useSelector } from "react-redux";
// const PendingBookings = () => {
//   const { token } = useSelector((state) => state.auth);
//   const navigate = useNavigate();
//   const [pendingBookings, setPendingBookings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchPendingBookings = async () => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     };

//     try {
//       const response = await axios.get(
//         `${baseUrl}/bookings/getBookingPendingCounselor`,
//         { headers }
//       );
//       setPendingBookings(response.data.data);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching bookings:", error);
//       setError("Failed to fetch bookings");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPendingBookings();
//   }, []);

//   const statusMap = {
//     0: "Pending",
//     1: "Accepted",
//     2: "Paid",
//     3: "Rejected",
//     4: "Upcoming",
//     5: "Completed",
//   };

//   const statusMapType = {
//     0: "default",
//     1: "success",
//     2: "secondary",
//     3: "error",
//     4: "warning",
//     5: "info",
//   };

//   const columnHelper = createMRTColumnHelper();

//   const columns = [
//     columnHelper.accessor("actions", {
//       header: "Actions",
//       Cell: ({ row }) => {
//         const { status, Scheduled, approved_slots } = row.original;
//         console.log(Scheduled, "Scheduled");

//         const handleClick = () => {
//           if (status !== 0) {
//             navigate("/essay-counseling-slot");
//           }
//         };

//         return (
//           <Box>
//             {approved_slots !== Scheduled && (
//               <button
//                 onClick={handleClick}
//                 className="w-32-px h-32-px bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
//                 style={{ cursor: "pointer" }}
//               >
//                 <Icon
//                   icon="material-symbols:create-new-folder-outline"
//                   width={18}
//                 />
//               </button>
//             )}
//           </Box>
//         );
//       },
//     }),

//     columnHelper.accessor("studentFirstName", {
//       header: "Student Name",
//       Cell: (cell) =>
//         `${cell.row.original.studentFirstName || ""} ${
//           cell.row.original.studentLastName || ""
//         }`,
//     }),

//     columnHelper.accessor("counselorinterestedIn", {
//       header: "Service Type",
//       Cell: (cell) => cell.row.original?.counselorinterestedIn || "-",
//     }),

//     columnHelper.accessor("approved_slots", {
//       header: "Total Slots",
//       Cell: (cell) => cell.row.original?.approved_slots ?? 0,
//     }),
//     columnHelper.accessor("Scheduled", {
//       header: "Scheduled Slots",
//       Cell: (cell) => cell.row.original?.Scheduled ?? 0,
//     }),

//     columnHelper.accessor("Unscheduled", {
//       header: "Pending Slots",
//       Cell: (cell) => {
//         return (
//           <Chip label={cell.row.original?.Unscheduled ?? 0} color="warning" />
//         );
//       },
//     }),
//     columnHelper.accessor("reqId", {
//       header: "Request ID",
//       Cell: (cell) => "DDR000" + cell.row.original?.reqId || "-",
//     }),
//   ];

//   return (
//     <CustomTable columns={columns} data={pendingBookings} loading={loading} />
//   );
// };

// export default PendingBookings;
